(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4058],{

/***/ 86231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...paths]]",
      function () {
        return __webpack_require__(48810);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _paths_; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(79570);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/react/index.js
var react = __webpack_require__(16405);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../libs/components/src/index.ts + 122 modules
var src = __webpack_require__(75762);
// EXTERNAL MODULE: ../../libs/page/src/index.ts + 17 modules
var page_src = __webpack_require__(74223);
// EXTERNAL MODULE: ../../libs/configs/src/index.ts + 7 modules
var configs_src = __webpack_require__(85109);
// EXTERNAL MODULE: ../../libs/utils/src/index.ts + 4 modules
var utils_src = __webpack_require__(77241);
;// CONCATENATED MODULE: ./lib/createJobPostingScripts.ts



const DEFAULT_JOB_DESCRIPTION = "See full job details, responsibilities, and requirements on the application page.";
const DEFAULT_REMOTE_COUNTRY = "Poland";
const DEFAULT_JOB_LOCALITY = "Warsaw";
const DEFAULT_JOB_COUNTRY_CODE = "PL";
const EMPLOYMENT_TYPES = [
    "FULL_TIME",
    "PART_TIME"
];
const isOpenPositionsSection = (section)=>section._type === "sectionOpenPositions";
const getDatePart = (value)=>value.split("T")[0];
const getDatePosted = (positionDatePosted, pageUpdatedAt)=>{
    if ((0,utils_src/* isNonEmptyString */.HH)(positionDatePosted)) {
        return getDatePart(positionDatePosted);
    }
    if ((0,utils_src/* isNonEmptyString */.HH)(pageUpdatedAt)) {
        return getDatePart(pageUpdatedAt);
    }
    return new Date().toISOString().split("T")[0];
};
const getDescription = (positionJsonLdDescription, positionDescription, sectionDescription)=>{
    if ((0,utils_src/* isNonEmptyString */.HH)(positionJsonLdDescription)) {
        return positionJsonLdDescription.trim();
    }
    if ((0,utils_src/* isNonEmptyString */.HH)(positionDescription)) return positionDescription.trim();
    if ((0,utils_src/* isNonEmptyString */.HH)(sectionDescription)) return sectionDescription.trim();
    return DEFAULT_JOB_DESCRIPTION;
};
const getEmploymentType = (employmentType)=>{
    if (!(0,utils_src/* isNonEmptyString */.HH)(employmentType)) return "FULL_TIME";
    return EMPLOYMENT_TYPES.includes(employmentType) ? employmentType : "FULL_TIME";
};
const getBaseSalary = (baseSalary)=>{
    if (typeof baseSalary !== "number" || Number.isNaN(baseSalary)) return undefined;
    if (baseSalary <= 0) return undefined;
    return {
        "@type": "MonetaryAmount",
        currency: "PLN",
        value: {
            "@type": "QuantitativeValue",
            unitText: "MONTH",
            value: baseSalary
        }
    };
};
const createJobPostingJsonLd = (position, sectionDescription, pageUpdatedAt)=>{
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "JobPosting",
        title: position.title,
        description: getDescription(position.jsonLdDescription, position.description, sectionDescription),
        datePosted: getDatePosted(position.datePosted, pageUpdatedAt),
        hiringOrganization: {
            "@type": "Organization",
            name: configs_src/* ORGANIZATION_NAME */.Rc,
            sameAs: configs_src/* ORGANIZATION_URL */.yz,
            logo: configs_src/* LOGO_URL */.oQ
        },
        jobLocationType: "TELECOMMUTE",
        jobLocation: {
            "@type": "Place",
            address: {
                "@type": "PostalAddress",
                addressLocality: DEFAULT_JOB_LOCALITY,
                addressCountry: DEFAULT_JOB_COUNTRY_CODE
            }
        },
        applicantLocationRequirements: {
            "@type": "Country",
            name: DEFAULT_REMOTE_COUNTRY
        },
        employmentType: getEmploymentType(position.employmentType),
        directApply: false
    };
    if ((0,utils_src/* isNonEmptyString */.HH)(position.validThrough)) {
        jsonLd.validThrough = position.validThrough;
    }
    const baseSalary = getBaseSalary(position.baseSalary);
    if (baseSalary) {
        jsonLd.baseSalary = baseSalary;
    }
    const ctaLink = position.ctaLink;
    if (ctaLink && (0,src/* isLinkHref */.mL)(ctaLink) && (0,utils_src/* isNonEmptyString */.HH)(ctaLink.href)) {
        jsonLd.url = ctaLink.href;
    }
    return jsonLd;
};
const createJobPostingScripts = (param)=>{
    let { pageBuilder , pageUpdatedAt  } = param;
    return (pageBuilder === null || pageBuilder === void 0 ? void 0 : pageBuilder.filter(isOpenPositionsSection).flatMap((section)=>(section.positions || []).map((position)=>({
                key: "".concat(section._key, "-").concat(position._key),
                jsonLd: createJobPostingJsonLd(position, section.description, pageUpdatedAt)
            })))) || [];
};

;// CONCATENATED MODULE: ./pages/[[...paths]].tsx








const BREADCRUMB_ROUTES = [
    {
        basePath: configs_src/* ROUTE_BASE_CASE_STUDY */.MQ,
        name: "Work"
    },
    {
        basePath: configs_src/* ROUTE_BASE_ARTICLE */.d5,
        name: "Insights"
    },
    {
        basePath: configs_src/* ROUTE_BASE_SERVICES */.FV,
        name: "Services"
    }
];
const Page = (props)=>{
    const { seo , disallowRobots , path , pageBuilder , _updatedAt  } = props;
    const { asPath  } = (0,router.useRouter)();
    const canonicalPath = (asPath === null || asPath === void 0 ? void 0 : asPath.split("?")[0]) || path || "";
    const canonicalUrl = "".concat("https://commerce-ui.com").concat(canonicalPath);
    const seoImage = (0,src/* seoImageLoader */.N1)(seo === null || seo === void 0 ? void 0 : seo.ogImage, seo === null || seo === void 0 ? void 0 : seo.ogAltImage);
    const breadcrumbRoute = BREADCRUMB_ROUTES.find((param)=>{
        let { basePath  } = param;
        return canonicalPath.startsWith("".concat(basePath, "/"));
    });
    const breadcrumbItems = [
        {
            position: 1,
            name: "Home",
            item: configs_src/* ORGANIZATION_URL */.yz
        }
    ];
    if (breadcrumbRoute) {
        breadcrumbItems.push({
            position: 2,
            name: breadcrumbRoute.name,
            item: "".concat(configs_src/* ORGANIZATION_URL */.yz).concat(breadcrumbRoute.basePath)
        });
        breadcrumbItems.push({
            position: 3,
            name: seo === null || seo === void 0 ? void 0 : seo.metaTitle,
            item: canonicalUrl
        });
    } else {
        breadcrumbItems.push({
            position: 2,
            name: seo === null || seo === void 0 ? void 0 : seo.metaTitle,
            item: canonicalUrl
        });
    }
    const breadcrumbJsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbItems.map((item)=>({
                "@type": "ListItem",
                ...item
            }))
    };
    const jobPostingJsonLdScripts = createJobPostingScripts({
        pageBuilder,
        pageUpdatedAt: _updatedAt
    });
    const seoElement = seo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        titleTemplate: seo === null || seo === void 0 ? void 0 : seo.titleTemplate,
        nofollow: disallowRobots,
        noindex: disallowRobots,
        title: seo.metaTitle,
        description: seo.metaDescription,
        canonical: canonicalUrl,
        openGraph: {
            url: canonicalUrl,
            type: "website",
            title: seo.ogTitle,
            description: seo.ogDescription,
            images: [
                ...seoImage ? [
                    seoImage
                ] : []
            ]
        },
        twitter: {
            cardType: "summary_large_image"
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        noindex: disallowRobots,
        nofollow: disallowRobots,
        canonical: canonicalUrl
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            seoElement,
            canonicalPath !== "/" && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(breadcrumbJsonLd)
                }
            }),
            jobPostingJsonLdScripts === null || jobPostingJsonLdScripts === void 0 ? void 0 : jobPostingJsonLdScripts.map((jobPostingJsonLdScript)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(jobPostingJsonLdScript.jsonLd)
                    }
                }, jobPostingJsonLdScript.key)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(page_src/* DefaultPage */.k, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _paths_ = (Page);


/***/ }),

/***/ 50339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(16405));
var _loadable = _interop_require_default(__webpack_require__(31597));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 51617:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(16405));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 31597:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(30199)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(16405));
var _loadableContext = __webpack_require__(51617);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(50339)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4223,2888,179], function() { return __webpack_exec__(86231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);